import { pick, omit } from 'lodash-es';
import api from '~/api';
import { applyTemplate } from '~/utils/url_template';

const DEFAULT_METHODS = {
  get: 'GET',
  create: 'POST',
  update: 'PATCH',
  destroy: 'DELETE',
};

export default class Resource {
  constructor(baseUrlTemplate, options = {}) {
    if (!baseUrlTemplate) {
      throw new Error('URL template is required');
    }

    let methods = DEFAULT_METHODS;
    const extraMethods = options.extra;
    const links = options.links;

    if (Array.isArray(options.only)) {
      methods = pick(methods, options.only);
    } else if (Array.isArray(options.except)) {
      methods = omit(methods, options.except);
    }

    for (const methodName in methods) {
      this[methodName] = (urlParams = {}, params = {}, options = {}) => {
        return this.request(baseUrlTemplate, urlParams, methods[methodName], params, options);
      };
    }

    if (typeof extraMethods === 'object') {
      for (const extraMethod in extraMethods) {
        const extraMethodDefinition = extraMethods[extraMethod];
        const method = extraMethodDefinition.method || 'GET';

        this[extraMethod] = (urlParams = {}, params = {}, options = {}) => {
          return this.request(extraMethodDefinition.url, urlParams, method, params, options);
        };
      }
    }

    if (typeof links === 'object') {
      for (const link in links) {
        this[`${link}Link`] = (params = {}, queryParams = {}) => applyTemplate(links[link], params, queryParams);
      }
    }
  }

  request(urlTemplate, urlParams, method, params, options) {
    const url = applyTemplate(urlTemplate, urlParams);

    if (options.unique) {
      options.abortDuplicateRequests = !!options.unique;
      delete options.unique;
    }

    return api.request(url, method, params, options);
  }
}
